import Swal from 'sweetalert2'
import {useNavigate} from 'react-router-dom'
import React, {useState} from 'react'
import {
  ILicenseTypes,
  LicenseTypesInitValues as initialValues,
} from '../../models/LicenseTypesModel'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import axios from 'axios'
import {useIntl} from 'react-intl'
import {Input3} from '../../../../../../components/Forms/Input'
import AsyncSelect from 'react-select/async'
import {colourStyles} from '../../../licenses/components/styles/styles'
import {Toolbar2} from '../../../../../../_metronic/layout/components/toolbar/Toolbar2'
import {PageTitle} from '../../../../../../_metronic/layout/core'

const API_URL = process.env.REACT_APP_API_URL || 'api'
export interface UseOption {
  readonly value: string
  readonly label: string
}

const LicenseTypesSchema = Yup.object().shape({
  abbreviate: Yup.string().required('Campo obrigatório'),
  description: Yup.string().required('Campo obrigatório'),
})

const FormLicenseTypesAdd: React.FC = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [, setSelectedAddIssueOrgans] = useState([])

  const intl = useIntl()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const resp = localStorage.getItem('auth_storage')
  let token = ''
  if (resp) {
    token = JSON.parse(resp)
  }
  let config = {
    headers: {
      Authorization: 'Bearer ' + token,
    },
  }

  // const [data, setData] = useState<IProduct>()
  // const updateData = (fieldsToUpdate: Partial<IProduct>): void => {
  //   const updatedData = Object.assign(data, fieldsToUpdate)
  //   setData(updatedData)
  // }

  const formik = useFormik<ILicenseTypes>({
    initialValues,
    validationSchema: LicenseTypesSchema,
    onSubmit: async (values) => {
      setLoading(true)
      try {
        await axios.post(API_URL + '/sga/v1/license_types', values, config)
        setLoading(false)
        Swal.fire({
          icon: 'success',
          title: intl.formatMessage({id: 'LICENSE_TYPES.SWAL_ADD'}),
          showConfirmButton: false,
          timer: 2000,
        })
        navigate('/license_types')
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: intl.formatMessage({id: 'LICENSE_TYPES.SWAL_ADD_ERROR'}),
          showConfirmButton: false,
          timer: 1500,
        })

        setLoading(false)
      }
    },
  })
  function resetInputs() {
    formik.resetForm()
  }

  // Carregar os dados do select
  const loadOptions = (inputValue: string, callback: (options: UseOption[]) => void) => {
    setTimeout(() => {
      getIssueOrgans()
      var units: any = []
      async function getIssueOrgans() {
        const {data} = await axios.get(API_URL + '/v1/issue_organs/select2')
        let Response = data.results

        for (const element of Response) {
          const unit: any = {
            value: element.id,
            label: element.name,
          }

          units.push(unit)
        }
      }
      callback(units)
    }, 1000)
  }

  // Insere os dados do select
  const handleInputChangeIssueOrgans = (event: any) => {
    var inputValue = []
    if (event) {
      for (const element of event) {
        inputValue.push(element.value)
      }
    }
    setSelectedAddIssueOrgans(event)
    formik.setFieldValue('issue_organ_id', inputValue)
    return {inputValue}
  }

  return (
    <div className='card card-custom mt-n8'>
      {/* Component Header de Cadastros. */}

      <Toolbar2 icon={false} subtitle={intl.formatMessage({id: 'COMMON.BACK_BUTTON'})} />
      <PageTitle breadcrumbs={[]}>
        {intl.formatMessage({id: 'LICENSE_TYPES.NEW_LICENSE'})}
      </PageTitle>

      <div id='kt_account_profile_details' className='collapse show'>
        <form onSubmit={formik.handleSubmit} noValidate className='form'>
          <div className='card-body border-top p-9'>
            <div className='row'>
              {/* INICIO ABBREVIATION */}
              <div className='col-lg-6'>
                <Input3
                  title={intl.formatMessage({id: 'LICENSE_TYPES.INPUT_ABBREVIATION'})}
                  placeholder={intl.formatMessage({id: 'LICENSE_TYPES.INPUT_ABBREVIATION'})}
                  {...formik.getFieldProps('abbreviate')}
                  required
                />
              </div>

              {/* FIM ABBREVIATION */}

              {/* INICIO DESCRIÇÃO ----------------------*/}
              <div className='col-lg-6'>
                <Input3
                  title={intl.formatMessage({id: 'COMMON.DESCRIPTION'})}
                  placeholder={intl.formatMessage({id: 'COMMON.DESCRIPTION'})}
                  {...formik.getFieldProps('description')}
                  required
                />
              </div>
              {/* FIM DESCRIÇÃO ------------------------------*/}
            </div>

            {/* INICIO ISSUE ORGANS */}

            <div className='row mt-3'>
              <div className='col-lg-12'>
                <label className='form-label fw-bold required'>
                  <span className='required'>
                    {intl.formatMessage({id: 'LICENSES.RESPONSIBLE_ISSUE_ORGAN'})}
                  </span>
                </label>
                <AsyncSelect
                  className='form-control form-control-sm form-control-solid p-0 pl-1'
                  styles={colourStyles}
                  isMulti
                  cacheOptions
                  loadOptions={loadOptions}
                  defaultOptions
                  filterOption={(option, inputValue) =>
                    option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
                  }
                  onChange={handleInputChangeIssueOrgans}
                  placeholder={intl.formatMessage({id: 'SELECT.INPUT_RESPONSIBLE_ISSUE_ORGAN'})}
                />
              </div>
            </div>

            {/* FIM ISSUE ORGANS */}

            {/* INICIO RENOVATION */}
            <div className='row mt-2'>
              <div className='d-flex col-lg-12 '>
                <label className='col-lg-2 col-form-label fw-bold required'>
                  {intl.formatMessage({id: 'LICENSE_TYPES.RENEWABLE'})}
                </label>
                <div className='form-check form-switch form-check-custom form-check-solid fw-bold me-10'>
                  <label className='form-check-label'>
                    {intl.formatMessage({id: 'COMMON.NO'})}
                    &nbsp;
                  </label>
                  <input
                    className='form-check-input h-20px w-30px'
                    type='checkbox'
                    {...formik.getFieldProps('renewable')}
                  />
                  <label className='form-check-label'>
                    {intl.formatMessage({id: 'COMMON.YES'})}
                  </label>
                </div>
              </div>
            </div>

            {/* FIM RENOVATION */}

            {/* INICIO EXPIRE */}
            <div className='row mb-3'>
              <div className='d-flex col-lg-12 '>
                <label className='col-lg-2 col-form-label fw-bold required'>
                  {intl.formatMessage({id: 'LICENSES.EXPIRATION'})}
                </label>
                <div className='form-check form-switch form-check-custom form-check-solid fw-bold me-10'>
                  <label className='form-check-label'>
                    {intl.formatMessage({id: 'COMMON.NO'})}
                    &nbsp;
                  </label>
                  <input
                    className='form-check-input h-20px w-30px'
                    type='checkbox'
                    {...formik.getFieldProps('expire')}
                  />
                  <label className='form-check-label'>
                    {intl.formatMessage({id: 'COMMON.YES'})}
                  </label>
                </div>
              </div>
            </div>
            {/* FIM EXPIRE */}

            <div className='d-flex justify-content-end py-6'>
              <button type='submit' className='btn btn-sm btn-primary' disabled={loading}>
                {!loading && intl.formatMessage({id: 'COMMON.SAVE_BUTTON'})}
                {loading && (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    {intl.formatMessage({id: 'COMMON.SAVING_BUTTON'})}{' '}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
              <button type='reset' onClick={resetInputs} className='btn btn-sm btn-secondary mx-2'>
                {intl.formatMessage({id: 'COMMON.CLEAR_BUTTON'})}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}

export {FormLicenseTypesAdd}
